import React from 'react';
import '../App.css';

function Projects(props) {
  return (
  <div>
    <div className="container">
    <div className="flex">
    <div className="infobox-1 sites">
    {/* <h1>Projects</h1> */}
    <div class="about-proj-info">
    <h2>Day 1 - Jan 27</h2>
    <img src="https://i.imgur.com/t6B2Uy6.png" class="preview" alt="30_website"></img>
    <p class="proj-info-about">Today's prompt is to create a portfolio site which I already have, so I decided to make a sub portfolio to store all the projects I create throughout the course of this challenge. This site was made with React.js and deployed with Google Firebase.</p>
    </div>
    <div class="about-proj-info">
    <h2>Day 2 - Jan 28</h2>
    <a href="http://bite-sized-face.surge.sh/"><img src="https://i.imgur.com/ce0RGub.jpg" class="preview" alt="movie_website"></img></a>
    <p class="proj-info-main">Today's task is to create an information site for a favorite movie. Anyone who knows me knows I LOVE horror films. I also really enjoy trying to recreate websites to a T without looking at the HTML & CSS. Here's the official site for the upcoming Jordan Peele horror film, <a href="https://www.usmovie.com">"Us" </a> and below a link to my attempt at recreating it. Made with HTML, SASS, and jQuery. </p>
    </div>
    </div>
    </div>
    </div>
    </div>
    );
  }
export default Projects;